module.exports = __FOREMAN_VENDOR__REACT_INTL__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__REACT_INTL__"
// module id = react-intl
// module chunks = 3